import { forwardingUrl } from "helpers/forwarding";
import { alert } from "services/alert";

function connectionAlert(err: Error) {
    if (err.message === "Failed to fetch") {
        alert({
            type: "error",
            message: "Соединение с сервером потеряно. Попробуйте обновить страницу.",
            title: "Ошибка.",
        });
    } else {
        alert({ type: "error", message: "Неудачный запрос", title: "Ошибка." });
    }
}

function options(): RequestInit {
    return {
        method: "GET",
        cache: "default",
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json; charset=utf-8",
            "X-Cargorun-Authorization": localStorage.getItem("token"),
        } as unknown as Headers,
    };
}

export function responseMiddleware(res: Response) {
    const { ok, status } = res;
    const isNoContent = ok && (status === 204 || status === 404);
    const isUnAuthorized = status === 204 || status === 401;
    const isException = status === 400;
    return (isNoContent || isUnAuthorized || isException ? res.text() : res.json())
        .then((nextRes) => {
            if (ok && status === 200) {
                return nextRes;
            } else if (isNoContent) {
                return alert({ type: "info", message: "По вашему запросу ничего не найдено", title: "Не найдено" });
            } else if (isUnAuthorized) {
                return alert({ type: "info", message: "Нет доступа к внешней системе", title: "Ошибка" });
            } else if (isException) {
                alert({ type: "error", message: "Произошла ошибка", title: "Ошибка" });
            } else {
                alert({ type: "error", message: "Произошла ошибка", title: "Ошибка" });
            }
        })
        .catch(() => alert({ type: "error", message: "Произошла внутренняя ошибка", title: "Ошибка" }));
}

const cargorunOrderTruckMatchings = (truckCargorunId: number) => {
    return fetch(
        `${forwardingUrl()}/api/CargorunOrderTruckMatchings/List?truckCargorunId=${truckCargorunId}`,
        options(),
    )
        .then((res) => responseMiddleware(res))
        .catch(connectionAlert);
};

const myCargorunOrderTruckMatchings = () => {
    return fetch(`${forwardingUrl()}/api/CargorunOrderTruckMatchings/MyList`, options())
        .then((res) => responseMiddleware(res))
        .catch(connectionAlert);
};

const getForwardingOrder = (id: number) => {
    return fetch(`${forwardingUrl()}/api/CargorunOrderTruckMatchings/GetConfirmed?id=${id}`, options())
        .then((res) => responseMiddleware(res))
        .catch(connectionAlert);
};

export { cargorunOrderTruckMatchings, myCargorunOrderTruckMatchings, getForwardingOrder };
